import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dialog, DialogActions, DialogContent, Stack } from "@mui/material";
import CloseButton from "../../../../components/commonComponents/Buttons/CloseButton";
import { Close, Preview } from "@mui/icons-material";
import ReportLayout from "./ReportLayout";
import { clearCampaignDetails } from "../../../../api_calls/utils";

const ReportPreview = ({ showModal, closeModal, campaignId }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    return (
        <>
            <Dialog
                open={showModal}
                onClose={(e) => {
                    e.preventDefault();
                }}
                fullScreen={true}
            >
                <DialogContent>
                    <ReportLayout campaignId={campaignId} />
                </DialogContent>
                <Box height={20} />
                <DialogActions>
                    <Stack direction={"row"} spacing={2}>
                        <CloseButton
                            onClick={(e) => {
                                e.preventDefault();
                                clearCampaignDetails();
                                closeModal(false);
                            }}
                            label="Cancel"
                            icon={<Close />}
                        />
                    </Stack>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ReportPreview;
